/**
 * Primitivo para campos `.secret` del DSL: el server nunca devuelve el valor
 * guardado, solo `<campo>HasValue`. Hay credencial válida si el server ya
 * tiene una guardada (`hasValue`) o si el usuario está tecleando una nueva
 * ahora mismo en el mismo formulario (`typed`, sin contar espacios en blanco).
 *
 * Reusable por cualquier entidad/campo `.secret`: no depende de TenantProfile.
 */
export const hasCredential = (
  hasValue: boolean | undefined,
  typed: string | null | undefined
): boolean => Boolean(hasValue) || Boolean(typed?.trim());

/**
 * El mismo criterio, pero distinguiendo lo que todavía no se sabe: `undefined`
 * cuando el `hasValue` del server no llegó (o el pedido falló) y el usuario
 * tampoco tecleó nada. Quien pregunta así no puede afirmar "falta credencial"
 * por omisión — tiene que comparar contra `false`.
 */
export const credentialState = (
  hasValue: boolean | undefined,
  typed: string | null | undefined
): boolean | undefined => {
  if (hasCredential(hasValue, typed)) return true;
  return hasValue === undefined ? undefined : false;
};
